import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { parsePrice } from 'src/utils/parse-price';
import { useTranslation } from 'react-i18next';

export default function ChangePricesConfirmDialog({prices, open, handleClose, handlePricesSave, handleBack}) {
  const { t } = useTranslation();
  return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box sx={{
          minWidth: '290px'
        }}>
          <DialogTitle id="alert-dialog-title">
            {t("views.productsManager.confirmPrices")}
          </DialogTitle>
          <DialogContent>
            <Table>
              <TableHead>
                  <TableRow>
                      <TableCell>{t("views.productsManager.oldPrice")}</TableCell>
                      <TableCell>{t("views.productsManager.newPrice")}</TableCell>
                  </TableRow>
              </TableHead>
              <TableBody>
                  {prices.map(p => {
                      return (
                          <TableRow key={p.id}>
                              <TableCell>{p.old ? parsePrice(p.old) : '-'}</TableCell>
                              <TableCell>{parsePrice(p.new)}</TableCell>
                          </TableRow>
                      )
                  })}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleBack}>{t("views.productsManager.back")}</Button>
            <Button onClick={handleClose} color='error'>{t("views.productsManager.cancel")}</Button>
            <Button onClick={handlePricesSave} autoFocus color="success">
            {t("views.productsManager.confirm")}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
  );
}